import { HOST } from "common-import/constants";
const numeral = require('numeral');

class VarHelper {
  detectType = variable => {
    switch(typeof variable) {
      case "number": return "number";
      case "string": return "string";
      case "undefined": return "undefined";
      case "boolean": return "boolean";
      case "function": return "function";
      case "object": 
        if(variable.constructor === Array) return "array";
        if(variable.constructor === Error) return "error";
        if(variable.constructor === Promise) return "promise";
      break;
      default: return "object";
    }
  }

  filterEmptyObjProp = obj => {
    let newObj = {};
    for (let prop in obj) {
      let value = obj[prop];
      if(value !== "" && value !== null && value !== undefined) newObj[prop] = value;
    }
    return newObj;
  }

  img = url => {
    if (typeof url !== 'string') return url;
    if (url.includes('http')) return url;
    return HOST + url;
  }

  groupInTwoArr = (arr) => {
    let newArr = [];
    let tempArr = [];
    for (let i = 0; i< arr.length; i++) {
      if (tempArr.length === 2) {
        tempArr.length = 0;
        tempArr.push(arr[i]);
        if (i === arr.length - 1) newArr.push(tempArr.slice());
      } else if (tempArr.length === 1) {
        tempArr.push(arr[i]);
        newArr.push(tempArr.slice());
      } else if (tempArr.length === 0) {
        tempArr.push(arr[i]);
        if (i === arr.length - 1) newArr.push(tempArr.slice());
      }
    }

    return newArr;
  }

  moneyString = number => {
    if (number === undefined) return undefined;
    return numeral(number).format('0,0');
  }
}

export default new VarHelper();


// WEBPACK FOOTER //
// ./src/utils/VarHelper.js